import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxErrorsModule } from '@ultimate/ngxerrors';
import { SelectModule } from 'ng-select';
import { Daterangepicker } from 'ng2-daterangepicker';
import { ModalModule } from 'ngx-boot-modal';
import { NgxPaginationModule } from 'ngx-pagination';

import { CheckDetailFormComponent } from './components/check/check-detail-form/check-detail-form.component';
import { CheckDetailItemComponent } from './components/check/check-detail-item/check-detail-item.component';
import { CheckHoursComponent } from './components/check/check-hours/check-hours.component';
import { CheckObservationsComponent } from './components/check/check-observations/check-observations.component';
import { CheckTotalTimeComponent } from './components/check/check-total-time/check-total-time.component';
import { CheckboxFieldComponent } from './components/forms/checkbox-field/checkbox-field.component';
import { DatepickerFieldComponent } from './components/forms/datepicker-field/datepicker-field.component';
import { InputEmailFieldComponent } from './components/forms/input-email-field/input-email-field.component';
import { InputFieldComponent } from './components/forms/input-field/input-field.component';
import { InputPasswordFieldComponent } from './components/forms/input-password-field/input-password-field.component';
import { InputTextFieldComponent } from './components/forms/input-text-field/input-text-field.component';
import { InputTimeFieldComponent } from './components/forms/input-time-field/input-time-field.component';
import { SelectFieldComponent } from './components/forms/select-field/select-field.component';
import { SubmitButtonComponent } from './components/forms/submit-button/submit-button.component';
import { TextareaFieldComponent } from './components/forms/textarea-field/textarea-field.component';
import { BackHeaderComponent } from './components/header/back-header/back-header.component';
import { EmptyHeaderComponent } from './components/header/empty-header/empty-header.component';
import { ListFilterComponent } from './components/list-filter/list-filter.component';
import { ListOrderComponent } from './components/list-order/list-order.component';
import { ConfirmModalComponent } from './components/modals/confirm-modal/confirm-modal.component';
import { DeleteConfirmModalComponent } from './components/modals/delete-confirm-modal/delete-confirm-modal.component';
import {
  ConfirmableNotificationOptionsComponent
} from './components/notifications/notifications-list/notification-item/confirmable-notification/confirmable-notification-options/confirmable-notification-options.component';
import {
  ConfirmableNotificationComponent
} from './components/notifications/notifications-list/notification-item/confirmable-notification/confirmable-notification.component';
import {
  EditCheckNotificationComponent
} from './components/notifications/notifications-list/notification-item/edit-check-notification/edit-check-notification.component';
import {
  NewCheckNotificationComponent
} from './components/notifications/notifications-list/notification-item/new-check-notification/new-check-notification.component';
import { NotificationItemComponent } from './components/notifications/notifications-list/notification-item/notification-item.component';
import { NotificationsListComponent } from './components/notifications/notifications-list/notifications-list.component';
import { SubmitDirective } from './directives/submit.directive';
import { UnlessDirective } from './directives/unless.directive';
import { CapitalizeAllPipe } from './pipes/capitalize-all.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { LiveTimeDifferencePipe } from './pipes/live-time-difference.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { TimePipe } from './pipes/time.pipe';

@NgModule({
  declarations: [
    // Components
    BackHeaderComponent,
    CheckboxFieldComponent,
    CheckDetailFormComponent,
    CheckDetailItemComponent,
    CheckHoursComponent,
    CheckObservationsComponent,
    CheckTotalTimeComponent,
    ConfirmableNotificationComponent,
    ConfirmableNotificationOptionsComponent,
    ConfirmModalComponent,
    DatepickerFieldComponent,
    DeleteConfirmModalComponent,
    EditCheckNotificationComponent,
    EmptyHeaderComponent,
    InputEmailFieldComponent,
    InputFieldComponent,
    InputPasswordFieldComponent,
    InputTextFieldComponent,
    InputTimeFieldComponent,
    ListFilterComponent,
    ListOrderComponent,
    NewCheckNotificationComponent,
    NotificationItemComponent,
    NotificationsListComponent,
    SelectFieldComponent,
    SubmitButtonComponent,
    TextareaFieldComponent,
    // Pipes
    CapitalizePipe,
    LiveTimeDifferencePipe,
    LocalizedDatePipe,
    TimePipe,
    CapitalizeAllPipe,
    // Directives
    SubmitDirective,
    UnlessDirective
  ],
  imports: [
    CommonModule,
    Daterangepicker,
    FormsModule,
    ModalModule,
    NgxErrorsModule,
    ReactiveFormsModule,
    RouterModule,
    SelectModule,
    TranslateModule
  ],
  exports: [
    // Modules
    CommonModule,
    Daterangepicker,
    ModalModule,
    NgxErrorsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SelectModule,
    TranslateModule,
    // Components
    BackHeaderComponent,
    CheckboxFieldComponent,
    CheckDetailFormComponent,
    CheckDetailItemComponent,
    CheckHoursComponent,
    CheckObservationsComponent,
    CheckTotalTimeComponent,
    DatepickerFieldComponent,
    DeleteConfirmModalComponent,
    EmptyHeaderComponent,
    InputEmailFieldComponent,
    InputPasswordFieldComponent,
    InputTextFieldComponent,
    InputTimeFieldComponent,
    ListFilterComponent,
    ListOrderComponent,
    NotificationItemComponent,
    NotificationsListComponent,
    SelectFieldComponent,
    SubmitButtonComponent,
    TextareaFieldComponent,
    // Pipes
    CapitalizeAllPipe,
    CapitalizePipe,
    LiveTimeDifferencePipe,
    LocalizedDatePipe,
    TimePipe,
    // Directives
    SubmitDirective,
    UnlessDirective
  ],
  providers: [
    // Pipes
    LocalizedDatePipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/shared/shared.module.ts